export const DeclarationsComponentName = 'declarationsComponent';
